import { IRevenueAgencyCrudModalLang, REVENUE_AGENCY_CRUD_MODAL_LANG_KEY } from './interface.IRevenueAgencyCrudModalLang'
import { IRevenueAgencyPageLang, REVENUE_AGENCY_PAGE_LANG_KEY } from './interface.IRevenueAgencyPageLang'
import { IRevenueAgencyListTableLang, REVENUE_AGENCY_LIST_TABLE_LANG_KEY } from './interface.IRevenueAgencyListTableLang'

export * from './interface.IRevenueAgencyCrudModalLang'
export * from './interface.IRevenueAgencyPageLang'
export * from './interface.IRevenueAgencyListTableLang'

export type IRevenueAgencyAllLang =
	& IRevenueAgencyPageLang
	& IRevenueAgencyCrudModalLang
	& IRevenueAgencyListTableLang

export const REVENUE_AGENCY_ALL_LANG_KEY: IRevenueAgencyAllLang = {
	...REVENUE_AGENCY_CRUD_MODAL_LANG_KEY,
	...REVENUE_AGENCY_LIST_TABLE_LANG_KEY,
	...REVENUE_AGENCY_PAGE_LANG_KEY
}